import { Navigate } from "react-router-dom"
import { isAuthenticated, isTokenExpired } from "../utils/localStorageOps"

function RedirectRoute({ children, redirectTo }){
    const Autenticado = (isAuthenticated() && !isTokenExpired())
    return Autenticado ? <Navigate to={redirectTo} /> : children
}

export default RedirectRoute